import { createFileRoute } from '@tanstack/react-router';
import { TaskRoutePage } from '@/pages/task/task-route-page';

export const Route = createFileRoute('/teams/$teamSlug/projects/$projectSlug/$taskKey')({
  component: TaskRoutePage,
});
